import template from './benefitDaysRequestSwitch.html';
import controller from './benefitDaysRequestSwitch.controller';
import './benefitDaysRequestSwitch.scss';

let BenefitDaysRequestSwitchComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    cardData: '<',
    displayMonth: '<',
    changeDays: '&',
    dayPeriods: '<',
  },
  template,
  controller,
};

export default BenefitDaysRequestSwitchComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestList/benefitRequestCard/BenefitDaysRequestSwitch/benefitDaysRequestSwitch.component.js